import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { LoadingComponent } from "./core/loading/loading.component";

import { PrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,  
  imports: [RouterOutlet, TranslateModule, LoadingComponent],
  providers: [MessageService],
  template: '<app-loading></app-loading><router-outlet/>',
  changeDetection: ChangeDetectionStrategy.OnPush, // TODO decidir si usar esta: Default,
})

export class AppComponent implements OnInit {

  title = 'SANITAS - Tratamiento dental';
  
  constructor(
    public translate: TranslateService,    
    private primeng: PrimeNG
  ) {
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang?.match(/en|es/) ? browserLang : 'es'); 
    this.translate.get('primeng').subscribe(res => this.primeng.setTranslation(res));   
  }

  ngOnInit() {    
    this.primeng.ripple.set(true);    
  }
}
